module.exports = __webpack_public_path__ + "img/ico_staff.b8c5097a.svg";